import React from 'react';
import PropTypes from 'prop-types';

const CreditCard = ({ className, color, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="-1 2 66 60"
    fill={color}
    stroke={color}
    strokeWidth="1px"
    {...props}
  >
    <path d="M59.31,57.9H53.23a.6.6,0,0,1,0-1.2h6.08c2.43,0,3.41-1,3.41-3.41V28.38a3,3,0,0,0-3-3H49.29l-33-.14a3.11,3.11,0,0,0-3,3.15V53.68a3,3,0,0,0,3,3h27.8a.6.6,0,0,1,0,1.2H16.31a4.22,4.22,0,0,1-4.21-4.22V28.39A4.34,4.34,0,0,1,16.31,24l31.85.13H59.71a4.21,4.21,0,0,1,4.2,4.22l0,24.91C63.93,56.35,62.38,57.9,59.31,57.9Z" />
    <line x1="13.03" y1="34.29" x2="62.83" y2="34.29" />
    <path d="M62.83,34.9H13a.61.61,0,0,1,0-1.21h49.8a.61.61,0,0,1,0,1.21Z" />
    <line x1="19.67" y1="49.98" x2="34.56" y2="49.98" />
    <path d="M34.56,50.58H19.67a.6.6,0,0,1,0-1.2H34.56a.6.6,0,0,1,0,1.2Z" />
    <path d="M12.58,41.07l-.12,0-9-1.8a4.23,4.23,0,0,1-3.31-5L5.09,9.49a4.23,4.23,0,0,1,5-3.31L52.6,14.7a4.23,4.23,0,0,1,3.3,5l-1,5.23a.6.6,0,0,1-.71.47.61.61,0,0,1-.47-.71l1-5.22a3,3,0,0,0-2.36-3.54L9.82,7.36A3,3,0,0,0,6.27,9.72L1.33,34.52A3,3,0,0,0,3.7,38.06l9,1.81a.61.61,0,0,1-.12,1.2Z" />
  </svg>
);

CreditCard.defaultProps = {
  className: '',
  color: 'currentColor',
};

CreditCard.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

export default CreditCard;
